import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadZone } from 'src/js/component/base/upload-zone';
import { useModalControls } from 'src/js/hook/use-modal-controls';
import { constant } from 'src/js/constant';
import { PresetOverwriteModal } from './preset-overwrite-modal';

interface Props {
  activateImportedPreset: boolean;
  autosave: boolean;
  handleImportPreset: (file: File) => void;
  onCancel?: VoidFunction;
  presetNames?: string[];
  setActivateImportedPreset: (bool: boolean) => void;
}

export const PresetImport: React.FunctionComponent<Props> = ({
  autosave,
  activateImportedPreset,
  presetNames = [],
  handleImportPreset,
  onCancel,
  setActivateImportedPreset,
}) => {
  const { t } = useTranslation();
  const [overwriteShown, showOverwrite, hideOverwrite] = useModalControls();
  const [userFile, setUserFile] = useState<any>(null);

  const onActivateImportedPreset = (e: React.ChangeEvent<HTMLInputElement>) => {
    setActivateImportedPreset(e.target.checked);
  };

  const handleContinueUpload = (file?: File): void => {
    if (file) {
      handleImportPreset(file);
    } else if (userFile) {
      handleImportPreset(userFile);
    }
  };

  const handleStartUpload = (file: File) => {
    setUserFile(file);
    if (presetNames.includes(file.name)) {
      showOverwrite();
      return;
    }
    handleContinueUpload(file);
  };

  const [showActivateCheckbox, setShowActivateCheckbox] = useState(false);
  const onFileChange = (file: File[]) => {
    // console.log('file', file);
    if (Array.isArray(file) && file.length > 0) {
      setShowActivateCheckbox(true);
    } else {
      setShowActivateCheckbox(false);
    }
    return true; // not handled
  };

  return (
    <>
      <div className="hai-mt-6">
        <UploadZone
          accept={{ '': constant.presetFileTypes }}
          checkedCheckbox={activateImportedPreset}
          onCancel={onCancel}
          onCheckboxChange={onActivateImportedPreset}
          onUpload={handleStartUpload}
          onFileChange={onFileChange}
          showCheckboxes={showActivateCheckbox} // only show once a file is selected R4KD-2189
          uploadBtnText={t('general.import')}
          uploadCheckboxText={autosave ? t('upload.activateImportedPreset') : t('upload.activateImportedPresetStartup')}
        />
      </div>
      {overwriteShown && (
        <PresetOverwriteModal
          name={userFile.name}
          onAccept={() => handleContinueUpload()} // Needed
          onCancel={hideOverwrite}
        />
      )}
    </>
  );
};
